import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import { Visitor } from 'src/app/models/visitor';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { ScreenType } from 'src/app/enums/ScreenType';
import { VisitorTokenExpiredDialogComponentComponent } from 'src/app/common/modules/dialog-pop-ups/components/visitor-token-expired-dialog-component/visitor-token-expired-dialog-component.component';
import { environment } from 'src/app/environments/environments';
import moment from 'moment';
@Component({
  selector: 'app-visitor-pass',
  templateUrl: './visitor-pass.component.html',
  styleUrls: ['./visitor-pass.component.scss'],
})
export class VisitorPassComponent implements OnInit {
  @ViewChild('pdfTable', { static: false }) pdfTable: ElementRef;
  @ViewChild('VisitorMsgDialog', { static: true })
  visitorMsgDialog: TemplateRef<any>;
  @ViewChild('canvasId') canvasId: ElementRef<HTMLCanvasElement>;
  @ViewChild('imageId') image: ElementRef<HTMLImageElement>;
  @ViewChild('VisitorDetailsSavedDialog', { static: true })
  visitorDetailsSavedDialog: TemplateRef<any>;
  @ViewChild('FetchingDialog', { static: true })
  fetchingDialog: TemplateRef<any>;

  visitorId: string;
  visitDT: any;
  qrData = '';
  visitorData: Visitor;
  urlProfile: any;
  urlID: any;
  securityStatus = 0;
  status: string;
  isVisitorUpload = false;
  isVisitorSelfVerified = false;
  urlProfileFile: any;
  urlIdFile: any;
  faceMatchMsg = '';
  showMsg = false;
  isRetry = false;
  isAPIRequest = false;
  disableButton = false;
  error = '';
  isFaceMatched = false;
  qrCodeData = '';
  isUploadedNewImage = false;
  isAlreadUploaded = false;
  public href: string = '';
  profilePicture: string = '';
  identityId: string = '';
  screenSize: ScreenType;
  ScreenType = ScreenType;
  uploadProgressId = 0;
  uploadProgressProfile = 0;
  baseServerURL = environment.apiUrl;
  constructor(
    private activeRoute: ActivatedRoute,
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private httpclient: HttpClient,
    private screen: AumyeResponsiveScreenService,
    private cdr: ChangeDetectorRef
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.activeRoute.queryParams.subscribe((params) => {
      this.visitorId = params['id'];
      this.qrData = this.visitorId;
    });
  }
  visitorSecurityEPass = this.formbuilder.group({
    orgID: [],
    visitorID: [],
    hostUserId: [],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.email]],
    phoneNumber: ['', Validators.required],
    visitorAddress: ['', Validators.required],
    purpose: ['', Validators.required],
    carRegistration: [],
    identityID: [''],
    hostName: ['', Validators.required],
    profilePicture: [''],
    securityStatus: [''],
    qrCode: [''],
    visitDateTime: [''],
    visitorCommentsTimeline: [''],
    isUnverifiedStatusCheckbox: [false],
  });
  ngOnInit(): void {
    const dialogRef = this.dialog.open(this.fetchingDialog, {
      disableClose: true,
    });
    let baseServerURL =
      this.baseServerURL + 'GetVisitorSecurityPass?id=' + this.visitorId;
    this.httpclient.get(baseServerURL).subscribe({
      next: (res: any) => {
        // Success callback
        this.visitorData = res;
        this.setVisitorSecurityForm(res);
        dialogRef.close();
      },
      error: (error: any) => {
        dialogRef.close();
        // Error callback
        this.dialog.open(VisitorTokenExpiredDialogComponentComponent, {
          disableClose: true,
          backdropClass: 'session-backdrop',
        });
      },
    });
  }
  setVisitorSecurityForm(val: any) {
    this.initializeCanvas();
    this.urlID = val.identityID;
    this.urlProfile = val.profilePicture;
    if (val.identityID && val.profilePicture) this.isAlreadUploaded = true;
    this.visitorSecurityEPass.controls.orgID.setValue(val.orgID);
    this.visitorSecurityEPass.controls.visitorCommentsTimeline.setValue(
      val.visitorCommentsTimeline
    );
    this.visitorSecurityEPass.value.identityID = this.urlID;
    this.visitorSecurityEPass.value.profilePicture = this.urlProfile;
    this.visitorSecurityEPass.controls.firstName.setValue(val.firstName);
    this.visitorSecurityEPass.controls.lastName.setValue(val.lastName);
    this.visitorSecurityEPass.controls.visitorID.setValue(val.visitorID);
    this.visitorSecurityEPass.controls.hostUserId.setValue(val.hostUserId);
    this.visitorSecurityEPass.controls.email.setValue(val.email);
    this.visitorSecurityEPass.controls.purpose.setValue(val.purpose);
    this.visitorSecurityEPass.controls.phoneNumber.setValue(val.phoneNumber);
    this.visitorSecurityEPass.controls.visitorAddress.setValue(
      val.visitorAddress
    );
    this.visitorSecurityEPass.controls.carRegistration.setValue(
      val.carRegistration
    );
    this.visitorSecurityEPass.controls.hostName.setValue(val.hostName);
    this.visitorSecurityEPass.controls.securityStatus.setValue(
      val.securityStatus
    );
    const visitDateTime = new Date(val.visitDateTime + 'Z');
    this.visitorSecurityEPass.controls.visitDateTime.setValue(
      moment(visitDateTime).format('DD/MM/YYYY, h:mm:ss A')
    );
    this.securityStatus = Number(
      this.visitorSecurityEPass.controls.securityStatus.value
    );
    this.status = this.securityStatus == 0 ? 'Unverified' : 'Verified';
    // if (this.securityStatus == 0) this.openDialog();
    this.captureScreen();
  }
  onSubmitSecurityVisitorPass() {
    this.visitorSecurityEPass.disable();
    this.visitorSecurityEPass.controls.visitDateTime.setValue(
      new Date().toISOString()
    );
    this.showMsg = true;
    this.disableButton = true;
    this.isAPIRequest = true;
    let baseServerURL = this.baseServerURL + 'UpdateVisitorSecurity';
    this.httpclient
      .post(baseServerURL, this.visitorSecurityEPass.value, {
        responseType: 'text',
      })
      .subscribe(
        (res) => {
          this.showMsg = false;
          this.isAPIRequest = false;
          if (res === 'success') {
            this.openSavedDialog();
            this.error = 'Details Saved! You can close this tab';
            setTimeout(() => {}, 1500);
          } else this.error = 'Please try again!';
        },
        (err) => {
          this.error = err.error;
          this.showMsg = false;
          this.isAPIRequest = false;
        }
      );
  }
  openSavedDialog() {
    const dialogRef = this.dialog.open(this.visitorDetailsSavedDialog, {
      disableClose: true,
    });
    setTimeout(() => {
      window.close();
    }, 1000);
  }
  dataURLtoFile(dataURL: string, filename: string) {
    let arr = dataURL.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  }
  onSelfVerifyVisitor() {
    this.ctx.clearRect(
      0,
      0,
      this.canvasId.nativeElement.width,
      this.canvasId.nativeElement.height
    );
    this.showMsg = true;
    this.isAPIRequest = true;
    let baseServerURL =
      this.baseServerURL + 'FaceRecognition?VisitorID=' + this.visitorId;
    const formData = new FormData();
    this.urlID = this.cropImage();
    const croppedFile = this.dataURLtoFile(this.urlID, 'cropped-image.png');
    this.urlIdFile = croppedFile;
    formData.append('File', this.urlIdFile, this.urlIdFile.name);
    formData.append('Photo', this.urlProfileFile, this.urlProfileFile.file);
    formData.append(
      'Name',
      this.visitorSecurityEPass.controls.firstName.value +
        ' ' +
        this.visitorSecurityEPass.controls.lastName.value
    );
    formData.append('Orgid', this.visitorSecurityEPass.value.orgID);
    this.httpclient
      .post(baseServerURL, formData, { responseType: 'text' })
      .subscribe(
        (res) => {
          this.faceMatchMsg = res;
          this.isAPIRequest = false;
          this.isRetry = false;
          this.isFaceMatched = true;
          this.visitorSecurityEPass.controls.securityStatus.setValue('1');
          this.securityStatus = Number(
            this.visitorSecurityEPass.controls.securityStatus.value
          );
          this.status = this.securityStatus == 0 ? 'Unverified' : 'Verified';
        },
        (err) => {
          this.error = 'Error: Please try again!';
          this.isRetry = true;
          this.visitorSecurityEPass.controls.securityStatus.setValue('0');
          this.securityStatus = Number(
            this.visitorSecurityEPass.controls.securityStatus.value
          );
          this.status = this.securityStatus == 0 ? 'Unverified' : 'Verified';
          this.faceMatchMsg = err.error
            ? err.error
            : 'Error: Please try again!';
          this.isAPIRequest = false;
          this.isFaceMatched = false;
        }
      );
  }
  onUploadProfile(event: any) {
    this.isUploadedNewImage = true;
    this.urlProfileFile = event.target.files[0];
    const file = event.target.files[0];

    if (file) {
      var reader = new FileReader();

      // Show progress during load
      reader.onprogress = (e) => {
        if (e.lengthComputable) {
          this.uploadProgressProfile = Math.round((e.loaded / e.total) * 100);
          // Force change detection
          this.cdr.detectChanges();
        }
      };

      reader.onload = (event: any) => {
        this.uploadProgressProfile = 100;
        this.urlProfile = event.target.result;
        this.profilePicture = ' Profile Added';

        // Force change detection after file is loaded
        this.cdr.detectChanges();
      };

      reader.readAsDataURL(file);
    }
  }
  onUploadID(event: any) {
    this.isUploadedNewImage = true;
    this.urlIdFile = event.target.files[0];
    const file = event.target.files[0];

    if (file) {
      var reader = new FileReader();

      // Show progress during load
      reader.onprogress = (e) => {
        if (e.lengthComputable) {
          this.uploadProgressId = Math.round((e.loaded / e.total) * 100);
          // Force change detection
          this.cdr.detectChanges();
        }
      };

      reader.onload = (event: any) => {
        this.uploadProgressId = 100;
        this.urlID = event.target.result;
        this.identityId = 'ID Added';

        // Keep your existing timeout for canvas updates
        setTimeout(() => {
          this.updateCanvasSize();
          if (this.screenSize === ScreenType.Mobile) this.drawImageAndPoints();
          else {
            this.drawImageAndPoints();
          }
          // Force change detection after canvas update
          this.cdr.detectChanges();
        }, 100);

        // Force immediate change detection for other UI elements
        this.cdr.detectChanges();
      };

      reader.readAsDataURL(file);
    }
  }
  captureScreen() {
    var data = this.pdfTable;
    html2canvas(data.nativeElement).then((canvas) => {
      const contentDataURL = canvas.toDataURL('image/png');
      this.qrCodeData = contentDataURL;
      this.visitorSecurityEPass.controls.qrCode.setValue(null);
    });
  }
  openDialog() {
    const dialogRef = this.dialog.open(this.visitorMsgDialog, {
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.isVisitorUpload = result;
      if (result) {
        this.visitorSecurityEPass.controls.identityID.setValidators(
          Validators.required
        );
      }
    });
  }
  onChangeImage() {
    this.isAlreadUploaded = false;
    this.urlID = '';
    this.urlProfile = '';
    this.visitorSecurityEPass.controls.securityStatus.setValue('0');
    this.securityStatus = Number(
      this.visitorSecurityEPass.controls.securityStatus.value
    );
    this.status = this.securityStatus == 0 ? 'Unverified' : 'Verified';
  }

  private points = [
    { x: 10, y: 10 },
    { x: 10, y: 90 },
    { x: 90, y: 10 },
    { x: 90, y: 90 },
  ];
  private draggingPoint = -1;
  private ctx: CanvasRenderingContext2D;
  startDrag(event: MouseEvent) {
    const { offsetX, offsetY } = event;
    this.points.forEach((point, index) => {
      if (
        offsetX > point.x - 5 &&
        offsetX < point.x + 5 &&
        offsetY > point.y - 5 &&
        offsetY < point.y + 5
      ) {
        this.draggingPoint = index;
      }
    });
  }
  dragPoint(event: MouseEvent) {
    if (this.draggingPoint !== -1) {
      const { offsetX, offsetY } = event;
      this.points[this.draggingPoint] = { x: offsetX, y: offsetY };
      this.drawImageAndPoints();
    }
  }

  endDrag(event: MouseEvent) {
    this.draggingPoint = -1;
  }
  private drawImageAndPoints() {
    this.sortPoints();
    const imgElement = this.image.nativeElement;
    const rect = imgElement.getBoundingClientRect();

    this.ctx.clearRect(
      0,
      0,
      this.canvasId.nativeElement.width,
      this.canvasId.nativeElement.height
    );
    this.ctx.drawImage(imgElement, 0, 0, rect.width, rect.height);

    // Draw the draggable points
    this.ctx.strokeStyle = 'red';
    this.ctx.lineWidth = 2;

    this.points.forEach((point, i) => {
      this.ctx.beginPath();
      this.ctx.arc(point.x, point.y, 10, 0, Math.PI * 2);
      this.ctx.fillStyle = i === this.draggingPoint ? 'blue' : 'red';
      this.ctx.fill();
      this.ctx.stroke();
    });

    // Connect points with lines
    this.ctx.beginPath();
    this.ctx.moveTo(this.points[0].x, this.points[0].y);
    this.ctx.lineTo(this.points[1].x, this.points[1].y);
    this.ctx.lineTo(this.points[2].x, this.points[2].y);
    this.ctx.lineTo(this.points[3].x, this.points[3].y);
    this.ctx.closePath();
    this.ctx.stroke();

    // Fill the enclosed region with semi-transparent color
    this.ctx.fillStyle = 'rgba(0, 0, 255, 0.2)'; // Blue with 20% opacity
    this.ctx.fill();
  }
  private sortPoints() {
    const centerX =
      this.points.reduce((sum, p) => sum + p.x, 0) / this.points.length;
    const centerY =
      this.points.reduce((sum, p) => sum + p.y, 0) / this.points.length;

    this.points.sort((a, b) => {
      const angleA = Math.atan2(a.y - centerY, a.x - centerX);
      const angleB = Math.atan2(b.y - centerY, b.x - centerX);
      return angleA - angleB;
    });
  }
  onTouchStart(event: TouchEvent) {
    event.preventDefault();
    const { clientX, clientY } = this.getTouchCoordinates(event);
    const rect = this.canvasId.nativeElement.getBoundingClientRect();
    const x = clientX - rect.left;
    const y = clientY - rect.top;

    this.points.forEach((point, index) => {
      if (
        x > point.x - this.touchAreaSize / 2 &&
        x < point.x + this.touchAreaSize / 2 &&
        y > point.y - this.touchAreaSize / 2 &&
        y < point.y + this.touchAreaSize / 2
      ) {
        this.draggingPoint = index;
      }
    });
  }
  touchAreaSize = 40;
  onTouchMove(event: TouchEvent) {
    event.preventDefault();
    if (this.draggingPoint !== -1) {
      const { clientX, clientY } = this.getTouchCoordinates(event);
      const rect = this.canvasId.nativeElement.getBoundingClientRect();
      const x = clientX - rect.left;
      const y = clientY - rect.top;

      this.points[this.draggingPoint] = { x, y };
      this.drawImageAndPoints();
    }
  }
  onTouchEnd(event: TouchEvent) {
    event.preventDefault();
    this.draggingPoint = -1;
  }
  private getTouchCoordinates(event: TouchEvent): {
    clientX: number;
    clientY: number;
  } {
    const touch = event.touches[0];
    return { clientX: touch.clientX, clientY: touch.clientY };
  }
  updateCanvasSize() {
    const imgElement = this.image.nativeElement;
    const canvasElement = this.canvasId.nativeElement;
    const rect = imgElement.getBoundingClientRect();

    canvasElement.width = rect.width;
    canvasElement.height = rect.height;
    canvasElement.style.width = `${rect.width}px`;
    canvasElement.style.height = `${rect.height}px`;
    // canvasElement.style.top = `${rect.top}px`;
    // canvasElement.style.left = `${rect.left}px`;
    this.updatePoints(rect.width, rect.height);
  }
  private updatePoints(imageWidth: number, imageHeight: number) {
    // Example default points: 10px margin from each side
    const margin = 10;
    this.points = [
      { x: margin, y: margin }, // Top-left
      { x: margin, y: imageHeight - margin }, // Bottom-left
      { x: imageWidth - margin, y: imageHeight - margin }, // Bottom-right
      { x: imageWidth - margin, y: margin }, // Top-right
    ];

    // Draw or update the canvas with the new points
  }
  private initializeCanvas() {
    this.ctx = this.canvasId.nativeElement.getContext('2d');
    this.updateCanvasSize();
  }
  cropImage() {
    const imgElement = this.image.nativeElement;
    const cropCanvas = document.createElement('canvas');
    const cropCtx = cropCanvas.getContext('2d');

    if (!cropCtx) {
      console.error('Failed to get canvas context.');
      return null;
    }

    // Calculate the rectangle dimensions based on the points
    const x = Math.min(this.points[0].x, this.points[2].x);
    const y = Math.min(this.points[0].y, this.points[2].y);
    const w = Math.abs(this.points[2].x - this.points[0].x);
    const h = Math.abs(this.points[2].y - this.points[0].y);

    // Calculate scale factors
    const scaleX = imgElement.naturalWidth / imgElement.width;
    const scaleY = imgElement.naturalHeight / imgElement.height;

    // Set canvas dimensions
    cropCanvas.width = w * scaleX;
    cropCanvas.height = h * scaleY;

    // Draw the cropped image
    cropCtx.drawImage(
      imgElement,
      x * scaleX,
      y * scaleY,
      w * scaleX,
      h * scaleY,
      0,
      0,
      cropCanvas.width,
      cropCanvas.height
    );

    // Get the cropped image as a base64 URL
    const croppedImage = cropCanvas.toDataURL('image/png');
    return croppedImage;
  }
}
